import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  matrixViewFromSavedLineas,
  fmtQtyMatriz,
  tallaLabel,
  colorLabel,
} from "../Produccion/a3PedidoMatrizUtils";
export { a3MatrizRowsToLineasEnvio } from "./logisticaUtils";

/** Matriz tallas/colores solo lectura (lineas envío o equivalente). */
export default function EnvioMatrizLectura({ lineas }) {
  const mv = matrixViewFromSavedLineas(lineas);
  if (!mv) {
    return (
      <Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 0.5 }}
        >
          Detalle en filas (familias distintas entre líneas o sin estructura de
          matriz)
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Fam H</TableCell>
              <TableCell>Talla H</TableCell>
              <TableCell>Fam V</TableCell>
              <TableCell>Talla V</TableCell>
              <TableCell align="right">Uds</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(lineas || []).map((l) => (
              <TableRow
                key={l.IdLogisticaEnvioLinea ?? `${l.CodTallaH}-${l.CodTallaV}`}
              >
                <TableCell>{l.CodFamTallaH}</TableCell>
                <TableCell>{l.CodTallaH}</TableCell>
                <TableCell>{l.CodFamTallaV}</TableCell>
                <TableCell>{l.CodTallaV}</TableCell>
                <TableCell align="right">{l.Unidades}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    );
  }

  const { famH, famV, tallasH, tallasV, qtyAt, colTotals, total } = mv;

  return (
    <Box>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 0.75 }}
      >
        Fam. tallas (columnas): <strong>{famH}</strong> · Fam. colores (filas):{" "}
        <strong>{famV}</strong>
      </Typography>
      <Box sx={{ overflowX: "auto", maxWidth: "100%" }}>
        <Table size="small" sx={{ minWidth: 400 }}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  position: "sticky",
                  left: 0,
                  bgcolor: "background.paper",
                  zIndex: 1,
                  fontWeight: 700,
                }}
              >
                Color / Talla
              </TableCell>
              {tallasH.map((h) => (
                <TableCell key={`eh-${String(h.CODTALLA)}`} align="center">
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>
                    {tallaLabel(h)}
                  </Typography>
                </TableCell>
              ))}
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                Σ fila (uds)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tallasV.map((v) => {
              const rowSum = tallasH.reduce(
                (s, h) => s + qtyAt(v.CODTALLA, h.CODTALLA),
                0,
              );
              return (
                <TableRow key={`ev-${String(v.CODTALLA)}`}>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      bgcolor: "background.paper",
                      zIndex: 1,
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                    }}
                  >
                    {colorLabel(v)}
                  </TableCell>
                  {tallasH.map((h) => {
                    const q = qtyAt(v.CODTALLA, h.CODTALLA);
                    return (
                      <TableCell
                        key={`ec-${String(v.CODTALLA)}-${String(h.CODTALLA)}`}
                        align="center"
                        sx={{ py: 0.5 }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: q > 0 ? "text.primary" : "text.disabled",
                            fontWeight: q > 0 ? 600 : 400,
                          }}
                        >
                          {q > 0 ? fmtQtyMatriz(q) : "—"}
                        </Typography>
                      </TableCell>
                    );
                  })}
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {fmtQtyMatriz(rowSum)}
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Σ columna (uds)</TableCell>
              {colTotals.map((ct, i) => (
                <TableCell
                  key={`ct-${i}`}
                  align="center"
                  sx={{ fontWeight: 600 }}
                >
                  {fmtQtyMatriz(ct)}
                </TableCell>
              ))}
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                {fmtQtyMatriz(total)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mt: 0.75 }}
      >
        Total matriz: <strong>{fmtQtyMatriz(total)} uds</strong>
      </Typography>
    </Box>
  );
}
